import { render, staticRenderFns } from "./InstalledThemesCard.vue?vue&type=template&id=707208a8&"
import script from "./InstalledThemesCard.vue?vue&type=script&lang=js&"
export * from "./InstalledThemesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports